import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSoundAction, playSoundAction, clearSoundAction } from "../../../../../redux/sound";

const AIMessagePopup = () => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const dispatch = useDispatch();
  const setSound = payload => { dispatch( setSoundAction( payload ) ) };
  const playSound = () => { dispatch( playSoundAction() ) };
  const clearSound = () => { dispatch( clearSoundAction() ) };

  useEffect( () => {
    setSound( { src : `${ process.env.PUBLIC_URL }/static/audio/lc_05_02_open.ogg` } );
    playSound();
    return () => {
      setTimeout( clearSound );
    };
  }, [] );

  return (
    <div className="lp-wrap lp-middle nothead">
      <div className="lp-container lc-alert type2 h_auto m_border0">
        <p className="lc-alert_txt fwm" dangerouslySetInnerHTML={ { __html : answeringQuestions.temporaryData.aiMsge } } />
        <div className="lc-alert_aniBtm type2 bg_addproblem" />
      </div>
    </div>
  );

};

export default AIMessagePopup;
